import React from 'react';
import ItemsManagement from '../../../components/inventory/ItemsManagement';

const Items = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-6">
      <ItemsManagement />
    </div>
  );
};

export default Items;

